import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FormGroup, FormRow, Row, Textarea } from "styles/forms/main";
import {
    FixedDigitsInput,
    Input,
    RejectionReason,
    UploadAttachments,
    VerifyComponent,
} from "components";
import { setMessage } from "modules/shared/notification/slice";
import { deleteSingleAttachment } from "modules/shared/api";
import { getUserRoles } from "modules/auth/slice";

function PersonalInfo({
    setNewSupplierData,
    newSupplierData,
    handleSupplierDetailsChange,
    isEditable,
    errorList,
    phoneNumberError,
    nationalIdError,
    supplierAttachments,
    setSupplierAttachments,
    selectedSupplierId,
    isQARole,
    handleObjections,
    objections,
    isAuthorizedToCreate,
}) {
    const dispatch = useDispatch();
    const [objection, setObjections] = useState({});
    const getCurrentUserRole = useSelector(getUserRoles()).filter((role) => role === "reviewer");
    const handleDeleteUploadedItem = (id) => {
        deleteSingleAttachment(id).then(() => {
            setSupplierAttachments(supplierAttachments.filter((item) => item?.id !== id));
            dispatch(
                setMessage({
                    content: `Attachment deleted successfully`,
                    isError: false,
                })
            );
        });
    };
    const openObjectionhandler = (fieldName) => {
        setObjections({
            ...objection,
            [fieldName]: {
                haveobjection: true,
                verified: false,
            },
        });
    };
    const handleVerify = (fieldName, item, section, category) => {
        setObjections({
            ...objection,
            [fieldName]: {
                verified: true,
                haveobjection: false,
            },
        });
        handleObjections(null, item, section, category, true);
    };

    const renderObjection = (objectionName) => {
        if (objections && objections[objectionName] && isAuthorizedToCreate) {
            return <RejectionReason content={objections[objectionName]} />;
        }
        return null;
    };

    return (
        <>
            <FormRow>
                <FormGroup>
                    <Row>
                        <Input
                            isEditable={isEditable}
                            label="Name (Arabic)"
                            name="arabicName"
                            type="text"
                            required
                            onChange={(e) => handleSupplierDetailsChange(e)}
                            value={newSupplierData?.arabicName}
                            placeholder="مثال: محمد أحمد محمود"
                            errorMessage={errorList?.arabicName ? errorList?.arabicName : ""}
                        />
                        {getCurrentUserRole[0] === "reviewer" && isQARole && (
                            <VerifyComponent
                                objectionHandler={() => openObjectionhandler("arabicName")}
                                handleVerify={() =>
                                    handleVerify(
                                        "arabicName",
                                        "Name (Arabic)",
                                        "Personal Info - Supplier",
                                        "supplier_profile"
                                    )
                                }
                                verifed={
                                    objection?.arabicName?.verified
                                        ? objection?.arabicName?.verified
                                        : false
                                }
                                objection={
                                    objection?.arabicName?.haveobjection
                                        ? objection?.arabicName?.haveobjection
                                        : false
                                }
                            />
                        )}
                        {renderObjection("Name (Arabic)")}
                    </Row>
                    {objection?.arabicName?.haveobjection && (
                        <Textarea
                            autoFocus
                            required
                            onBlur={(e) => {
                                handleObjections(
                                    e,
                                    "Name (Arabic)",
                                    "Personal Info - Supplier",
                                    "supplier_profile",
                                    false
                                );
                            }}
                        />
                    )}
                </FormGroup>
                <FormGroup>
                    <Row>
                        <Input
                            isEditable={isEditable}
                            label="Mobile Number"
                            name="phoneNumber"
                            type="text"
                            required
                            value={newSupplierData?.phoneNumber}
                            onChange={(e) => handleSupplierDetailsChange(e)}
                            placeholder="0100000000"
                            errorMessage={
                                errorList?.phoneNumber ? errorList?.phoneNumber : phoneNumberError
                            }
                        />
                        {getCurrentUserRole[0] === "reviewer" && isQARole && (
                            <VerifyComponent
                                objectionHandler={() => openObjectionhandler("phoneNumber")}
                                handleVerify={() =>
                                    handleVerify(
                                        "phoneNumber",
                                        "Mobile Number",
                                        "Personal Info - Supplier",
                                        "supplier_profile"
                                    )
                                }
                                verifed={
                                    objection?.phoneNumber?.verified
                                        ? objection?.phoneNumber?.verified
                                        : false
                                }
                                objection={
                                    objection?.phoneNumber?.haveobjection
                                        ? objection?.phoneNumber?.haveobjection
                                        : false
                                }
                            />
                        )}
                        {renderObjection("Mobile Number")}
                    </Row>
                    {objection?.phoneNumber?.haveobjection && (
                        <Textarea
                            autoFocus
                            required
                            onBlur={(e) => {
                                handleObjections(
                                    e,
                                    "Mobile Number",
                                    "Personal Info - Supplier",
                                    "supplier_profile",
                                    false
                                );
                            }}
                        />
                    )}
                </FormGroup>
            </FormRow>
            <FormRow>
                <FormGroup>
                    <Row>
                        <Input
                            isEditable={isEditable}
                            label="Email"
                            name="email"
                            type="text"
                            required={false}
                            value={newSupplierData?.email}
                            onChange={(e) => handleSupplierDetailsChange(e)}
                            placeholder="example@mail.com"
                            errorMessage={errorList?.email && errorList?.email}
                        />
                        {getCurrentUserRole[0] === "reviewer" && isQARole && (
                            <VerifyComponent
                                objectionHandler={() => openObjectionhandler("email")}
                                handleVerify={() =>
                                    handleVerify(
                                        "email",
                                        "Email",
                                        "Personal Info - Supplier",
                                        "supplier_profile"
                                    )
                                }
                                verifed={
                                    objection?.email?.verified ? objection?.email?.verified : false
                                }
                                objection={
                                    objection?.email?.haveobjection
                                        ? objection?.email?.haveobjection
                                        : false
                                }
                            />
                        )}
                        {renderObjection("Email")}
                    </Row>
                    {objection?.email?.haveobjection && (
                        <Textarea
                            autoFocus
                            required
                            onBlur={(e) => {
                                handleObjections(
                                    e,
                                    "Email",
                                    "Personal Info - Supplier",
                                    "supplier_profile",
                                    false
                                );
                            }}
                        />
                    )}
                </FormGroup>
                <FormGroup>
                    <Row>
                        <FixedDigitsInput
                            key={newSupplierData?.nationalId}
                            label="National ID Number"
                            fields={14}
                            name="nationalId"
                            placeholder=""
                            required
                            onChange={(value) => handleSupplierDetailsChange(value, "nationalId")}
                            value={newSupplierData?.nationalId}
                            errorMessage={
                                errorList?.nationalId ? errorList?.nationalId : nationalIdError
                            }
                            autoFocus
                            disabled={!isEditable}
                        />
                        {getCurrentUserRole[0] === "reviewer" && isQARole && (
                            <VerifyComponent
                                objectionHandler={() => openObjectionhandler("nationalId")}
                                handleVerify={() =>
                                    handleVerify(
                                        "nationalId",
                                        "Nationality ID Number",
                                        "Personal Info - Supplier",
                                        "supplier_profile"
                                    )
                                }
                                verifed={
                                    objection?.nationalId?.verified
                                        ? objection?.nationalId?.verified
                                        : false
                                }
                                objection={
                                    objection?.nationalId?.haveobjection
                                        ? objection?.nationalId?.haveobjection
                                        : false
                                }
                            />
                        )}
                        {renderObjection("Nationality ID Number")}
                    </Row>
                    {objection?.nationalId?.haveobjection && (
                        <Textarea
                            autoFocus
                            required
                            onBlur={(e) => {
                                handleObjections(
                                    e,
                                    "Nationality ID Number",
                                    "Personal Info - Supplier",
                                    "supplier_profile",
                                    false
                                );
                            }}
                        />
                    )}
                </FormGroup>
            </FormRow>

            <FormRow>
                <FormGroup>
                    <Row>
                        <UploadAttachments
                            label="ID Photo - Face"
                            onFilesChange={(e) => handleSupplierDetailsChange(e, "nationalIdFace")}
                            isEditable={isEditable}
                            errorMessage={errorList?.nationalIdFace && errorList?.nationalIdFace}
                            required
                            onDeleteUploadedItem={handleDeleteUploadedItem}
                            uploadedAttachments={
                                selectedSupplierId &&
                                supplierAttachments?.filter(
                                    (item) => item?.documentType === "national_id_face"
                                )
                            }
                            maxLength={1}
                            showConfirmation
                        />
                        {getCurrentUserRole[0] === "reviewer" &&
                            supplierAttachments?.filter(
                                (item) => item?.documentType === "national_id_face"
                            )?.length === 1 &&
                            isQARole && (
                                <VerifyComponent
                                    objectionHandler={() => openObjectionhandler("nationalIdFace")}
                                    handleVerify={() =>
                                        handleVerify(
                                            "nationalIdFace",
                                            "ID Photo - Face",
                                            "Personal Info - Supplier",
                                            "supplier_profile"
                                        )
                                    }
                                    verifed={
                                        objection?.nationalIdFace?.verified
                                            ? objection?.nationalIdFace?.verified
                                            : false
                                    }
                                    objection={
                                        objection?.nationalIdFace?.haveobjection
                                            ? objection?.nationalIdFace?.haveobjection
                                            : false
                                    }
                                />
                            )}
                        {renderObjection("ID Photo - Face")}
                    </Row>
                    {objection?.nationalIdFace?.haveobjection && (
                        <Textarea
                            autoFocus
                            required
                            onBlur={(e) => {
                                handleObjections(
                                    e,
                                    "ID Photo - Face",
                                    "Personal Info - Supplier",
                                    "supplier_profile",
                                    false
                                );
                            }}
                        />
                    )}
                </FormGroup>
                <FormGroup>
                    <Row>
                        <UploadAttachments
                            label="ID Photo - Back"
                            onFilesChange={(e) => handleSupplierDetailsChange(e, "nationalIdBack")}
                            isEditable={isEditable}
                            name="nationalIdBack"
                            errorMessage={errorList?.nationalIdBack && errorList?.nationalIdBack}
                            required
                            onDeleteUploadedItem={handleDeleteUploadedItem}
                            uploadedAttachments={
                                selectedSupplierId &&
                                supplierAttachments?.filter(
                                    (item) => item?.documentType === "national_id_back"
                                )
                            }
                            maxLength={1}
                            showConfirmation
                        />
                        {getCurrentUserRole[0] === "reviewer" &&
                            supplierAttachments?.filter(
                                (item) => item?.documentType === "national_id_back"
                            )?.length === 1 &&
                            isQARole && (
                                <VerifyComponent
                                    objectionHandler={() => openObjectionhandler("nationalIdBack")}
                                    handleVerify={() =>
                                        handleVerify(
                                            "nationalIdBack",
                                            "ID Photo - Back",
                                            "Personal Info - Supplier",
                                            "supplier_profile"
                                        )
                                    }
                                    verifed={
                                        objection?.nationalIdBack?.verified
                                            ? objection?.nationalIdBack?.verified
                                            : false
                                    }
                                    objection={
                                        objection?.nationalIdBack?.haveobjection
                                            ? objection?.nationalIdBack?.haveobjection
                                            : false
                                    }
                                />
                            )}
                        {renderObjection("ID Photo - Back")}
                    </Row>
                    {objection?.nationalIdBack?.haveobjection && (
                        <Textarea
                            autoFocus
                            required
                            onBlur={(e) => {
                                handleObjections(
                                    e,
                                    "ID Photo - Back",
                                    "Personal Info - Supplier",
                                    "supplier_profile",
                                    false
                                );
                            }}
                        />
                    )}
                </FormGroup>
                <FormGroup>
                    <Row>
                        <UploadAttachments
                            label="Supplier Picture"
                            onFilesChange={(e) =>
                                setNewSupplierData({
                                    ...newSupplierData,
                                    supplierPictureAttachments: e,
                                })
                            }
                            isEditable={isEditable}
                            onDeleteUploadedItem={handleDeleteUploadedItem}
                            uploadedAttachments={
                                selectedSupplierId &&
                                supplierAttachments?.filter(
                                    (item) => item?.documentType === "picture"
                                )
                            }
                            maxLength={1}
                            showConfirmation
                        />
                        {getCurrentUserRole[0] === "reviewer" &&
                            supplierAttachments?.filter((item) => item?.documentType === "picture")
                                ?.length === 1 &&
                            isQARole && (
                                <VerifyComponent
                                    objectionHandler={() => openObjectionhandler("supplierPicture")}
                                    handleVerify={() =>
                                        handleVerify(
                                            "supplierPicture",
                                            "Supplier Picture",
                                            "Personal Info - Supplier",
                                            "supplier_profile"
                                        )
                                    }
                                    verifed={
                                        objection?.supplierPicture?.verified
                                            ? objection?.supplierPicture?.verified
                                            : false
                                    }
                                    objection={
                                        objection?.supplierPicture?.haveobjection
                                            ? objection?.supplierPicture?.haveobjection
                                            : false
                                    }
                                />
                            )}
                        {renderObjection("Supplier Picture")}
                    </Row>
                    {objection?.supplierPicture?.haveobjection && (
                        <Textarea
                            required
                            autoFocus
                            onBlur={(e) => {
                                handleObjections(
                                    e,
                                    "Supplier Picture",
                                    "Personal Info - Supplier",
                                    "supplier_profile",
                                    false
                                );
                            }}
                        />
                    )}
                </FormGroup>
            </FormRow>
        </>
    );
}

export default PersonalInfo;
